<template>
  <div class="task-manage-container">
    <star-condition-layout
      :onSearch="handleSearch"
      :onReset="reset"
      :loading="loading"
      ref="condition"
    >
      <star-condition-cell label="站点名称">
        <a-input v-model="search.spiderName" style="width: 100%" allowClear> </a-input>
      </star-condition-cell>
      <star-condition-cell label="站点类型">
        <a-select v-model="search.spiderClassType" style="width: 100%" allowClear>
          <a-select-option
            v-for="item in spiderClassOptions"
            :key="item.spiderClassId"
            :value="item.type"
            >{{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="站点Id">
        <a-input v-model="search.spiderId" style="width: 100%"> </a-input>
      </star-condition-cell>
      <star-condition-cell label="任务状态">
        <a-select v-model="search.taskStatus" style="width: 100%" allowClear>
          <a-select-option
            v-for="(item, index) in taskStatusOptions"
            :key="index"
            :value="item.value"
            >{{ item.label }}
          </a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="任务类型">
        <a-select v-model="search.taskType" style="width: 100%" allowClear>
          <a-select-option v-for="(item, index) in taskTypeOptions" :key="index" :value="item.value"
            >{{ item.label }}
          </a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="调度任务Id">
        <a-input v-model="search.taskId" style="width: 100%" allowClear> </a-input>
      </star-condition-cell>
      <star-condition-cell label="创建时间">
        <a-range-picker
          style="width: 136%"
          v-model="search.publishTime"
          :show-time="{ format: 'HH:mm:ss' }"
          value-format="YYYY-MM-DD HH:mm:ss"
          :placeholder="['开始日期', '结束日期']"
        />
      </star-condition-cell>

      <!--      <star-condition-cell label="服务器Ip">-->
      <!--        <a-input v-model="search.serverIp" style="width: 100%" allowClear> </a-input>-->
      <!--      </star-condition-cell>-->
    </star-condition-layout>

    <div class="table-container">
      <TableHeadIcons
        :onRefresh="queryScheduleRecordList"
        :size.sync="tableDensity"
        :columns="columns"
      />

      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="taskId"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="spiderName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title"> {{ record.spiderName }} </template>
            <span>
              {{ record.spiderName }}
            </span>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>
        </span>

        <span slot="spiderId" slot-scope="text, record">
          <a-tooltip>
            <template slot="title"> {{ record.spiderId }} </template>
            <span>
              {{ record.spiderId }}
            </span>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>
        </span>

        <span slot="execTime" slot-scope="text, record">{{
          record.execTime | formatDuration
        }}</span>
        <span slot="waitTime" slot-scope="text, record">{{
          record.waitTime | formatDuration
        }}</span>
        <span slot="totalTime" slot-scope="text, record">{{
          record.totalTime | formatDuration
        }}</span>

        <span slot="taskType" slot-scope="text, record">
          <a-badge
            v-if="record.taskType == 0"
            color="green"
            :text="taskTypeFilter(record.taskType)"
          >
          </a-badge>
          <a-badge
            v-else-if="record.taskType == 1"
            color="orange"
            :text="taskTypeFilter(record.taskType)"
          ></a-badge>
          <a-badge v-else color="red" :text="taskTypeFilter(record.taskType)"></a-badge>
        </span>
        <span slot="taskStatus" slot-scope="text, record">
          <a-badge
            v-if="record.taskStatus == 0"
            color="green"
            :text="taskStatusFilter(record.taskStatus)"
          >
          </a-badge>
          <a-badge
            v-else-if="record.taskStatus == 1"
            color="cyan"
            :text="taskStatusFilter(record.taskStatus)"
          >
          </a-badge>
          <a-badge
            v-else-if="record.taskStatus == 2"
            color="blue"
            :text="taskStatusFilter(record.taskStatus)"
          >
          </a-badge>
          <a-badge
            v-else-if="record.taskStatus == 3"
            color="purple"
            :text="taskStatusFilter(record.taskStatus)"
          >
          </a-badge>
          <a-badge
            v-else-if="record.taskStatus == 4"
            color="pink"
            :text="taskStatusFilter(record.taskStatus)"
          ></a-badge>
          <a-badge v-else color="red" :text="taskStatusFilter(record.taskStatus)"></a-badge>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button @click="stopDispatch(record)" type="link">停止任务 </a-button>
          <a-divider type="vertical"></a-divider>
          <a-button @click="showLog(record)" type="link">日志 </a-button>
          <a-divider type="vertical"></a-divider>
          <router-link
            :to="{
              name: 'dispatch_task_info',
              query: {
                taskId: record.taskId,
                spiderId: record.spiderId,
                logUrl: record.logUrl,
                spiderClassType: record.spiderClassType
              }
            }"
          >
            <a-button type="link">详情 </a-button>
          </router-link>
          <a-divider type="vertical"></a-divider>
          <a-button @click="handleHandExec(record)" type="link">重爬 </a-button>
          <a-divider type="vertical"></a-divider>
          <a-button @click="handleEdit(record)" type="link">站点配置 </a-button>
        </span>
      </a-table>
    </div>
    <a-modal
      title="日志"
      :maskClosable="false"
      :width="logModalWidth"
      :visible="isShowLogModal"
      :footer="null"
      @cancel="isShowLogModal = false"
    >
      <TaskLog
        :logUrl="logUrl"
        :terminalHeight="`${logoModalTerminalHight}px`"
        :taskId="logTaskId"
        v-if="isShowLogModal"
      />
    </a-modal>
  </div>
</template>

<script>
import { stopDispatchApi, queryScheduleRecordListApi } from '@/api/Dispatch/TaskManage'
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import TaskLog from '../TaskManageInfo/TaskLog'
import { onHttpResponse } from '@/utils/request'
import TableHeadIcons from '@/components/TableHeadIcons'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'
import { taskStatusOptions } from '../dict'
import moment from 'moment'
import { execApiItemApi, execNewsItemApi } from '@/api/Site/Manage'

const allowClassTypes = ['news', 'api', 'document', 'wechat']

export default {
  components: { TaskLog, TableHeadIcons },
  mixins: [tableSettingToStoreMixin()],
  data() {
    return {
      search: {
        spiderName: '',
        spiderClassType: undefined,
        taskType: undefined,
        taskStatus: undefined,
        taskId: undefined,
        spiderId: undefined,
        serverIp: undefined,
        publishTime: [
          // moment().format('YYYY-MM-DD') + ' 00:00:00',
          // moment().format('YYYY-MM-DD') + ' 23:59:59'
        ]
      },
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      tableData: [],
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'center',
          show: true,
          slots: { title: 'indexTitle' },
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '站点名称',
          dataIndex: 'spiderName',
          show: true,
          scopedSlots: { customRender: 'spiderName' }
        },
        {
          title: '站点类型',
          dataIndex: 'spiderClassName',
          show: true,
          scopedSlots: { customRender: 'spiderClassName' },
          ellipsis: true,
          width: 80,
          align: 'center'
        },

        {
          title: '站点id',
          dataIndex: 'spiderId',
          show: true,
          scopedSlots: { customRender: 'spiderId' },
          ellipsis: true,
          align: 'center'
        },

        {
          title: '任务类型',
          dataIndex: 'taskType',
          show: false,
          scopedSlots: { customRender: 'taskType' },
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '任务状态',
          dataIndex: 'taskStatus',
          show: true,
          scopedSlots: { customRender: 'taskStatus' },
          ellipsis: true,
          width: 80,
          align: 'center'
        },
        {
          title: '开始时间',
          dataIndex: 'taskCreateTime',
          show: true,
          width: 180,
          ellipsis: true,
          scopedSlots: { customRender: 'taskCreateTime' },
          align: 'center'
        },
        {
          title: '结束时间',
          dataIndex: 'taskEndTime',
          show: false,
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'taskEndTime' },
          align: 'center'
        },
        {
          title: '运行时长',
          dataIndex: 'execTime',
          show: true,
          width: 80,
          scopedSlots: { customRender: 'execTime' },
          align: 'center'
        },

        {
          title: '等待时长',
          dataIndex: 'waitTime',
          show: true,
          width: 90,
          scopedSlots: { customRender: 'waitTime' },
          align: 'center'
        },
        {
          title: '总时长',
          dataIndex: 'totalTime',
          show: false,
          width: 90,
          scopedSlots: { customRender: 'totalTime' },
          align: 'center'
        },
        {
          title: '结果数',
          dataIndex: 'resultNum',
          show: true,
          width: 90,
          scopedSlots: { customRender: 'resultNum' },
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 400,
          align: 'center'
        }
      ],
      loading: false,
      spiderClassOptions: [],
      taskTypeOptions: [
        {
          label: '自动',
          value: '0'
        },
        {
          label: '手动',
          value: '1'
        }
      ],
      taskStatusOptions: taskStatusOptions,
      visible: false,

      tableDensity: 'middle',
      isShowColFilterOverlay: false,

      isShowLogModal: false,
      logUrl: '',
      logTaskId: '',
      logModalWidth: window.innerWidth * 0.9,
      logoModalTerminalHight: window.innerHeight - 400,

      defaultErrorCode: undefined,
      defaultServerIp: undefined
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  created() {
    if (sessionStorage.refresh === 'close') {
      sessionStorage.refresh = undefined
      this.queryScheduleRecordList()
    } else {
      const { serverIp, errorCode, spiderId, errorStartTime, errorEndTime } = this.$route.query
      if (errorStartTime) {
        this.search.publishTime = [errorStartTime, errorEndTime]
        this.search.spiderId = spiderId
      }
      if (serverIp) {
        this.search.serverIp = serverIp
        // 展开
        this.$refs.condition.open()
      }
      if (errorCode !== undefined) {
        this.search.taskStatus = errorCode.toString()
      }
      this.querySpiderClassInfoApi()
      this.queryScheduleRecordList()
    }
  },
  methods: {
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success('已复制')
    },
    // 复制失败时的回调函数
    onCopyError(e) {
      this.$message.error('复制失败')
    },
    copy: function () {
      var _this = this
      var clipboard = new Clipboard('#copy_text')

      clipboard.on('success', (e) => {
        message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        Message({
          message: '该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },

    taskTypeFilter(value) {
      let res = this.taskTypeOptions.filter((item) => item.value == value)
      if (res.length > 0) {
        return res[0].label
      } else {
        return '未知'
      }
    },
    taskStatusFilter(value) {
      let res = this.taskStatusOptions.filter((item) => item.value == value)
      if (res.length > 0) {
        return res[0].label
      } else {
        return '未知'
      }
    },
    handleInfo({ taskId, logUrl }) {
      this.$router.push({
        name: 'dispatch_task_info',
        query: {
          taskId,
          logUrl
        }
      })
    },

    async querySpiderClassInfoApi() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code == '200') {
        this.spiderClassOptions = data.filter((d) => allowClassTypes.includes(d.type))
      } else {
        this.$message.error(msg)
      }
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.queryScheduleRecordList()
    },

    handleSearch() {
      this.pagination.current = 1
      this.queryScheduleRecordList()
    },

    async queryScheduleRecordList() {
      if (this.search.publishTime != undefined) {
        this.search.startTime = this.search.publishTime[0]
        this.search.endTime = this.search.publishTime[1]
      }
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...JSON.parse(JSON.stringify(this.search))
      }
      delete query.publishTime
      this.loading = true
      let res = await queryScheduleRecordListApi(query)
      this.loading = false
      let { code, msg, data, extra } = res
      if (code == '200') {
        this.tableData = data
        this.pagination.total = extra.page.pageCount || 0
      } else {
        this.$message.error(msg)
      }
    },

    onTableDensityChange(density) {
      this.tableDensity = density
    },

    reset() {
      this.search.spiderName = ''
      this.search.taskStatus = undefined
      this.search.spiderClassType = undefined
      this.search.taskType = undefined
      this.search.taskId = undefined
      this.search.spiderId = undefined
      this.search.publishTime = undefined
      this.search.startTime = undefined
      this.search.endTime = undefined
      this.handleSearch()
    },

    showLog(record) {
      // this.logUrl = record.logUrl
      // this.logTaskId = record.taskId
      // this.isShowLogModal = true
      window.open(record.logUrl)
    },

    stopDispatch(record) {
      this.$confirm({
        title: '停止任务确认',
        content: '是否立刻停止任务?',
        autoFocusButton: 'ok',
        okText: '立刻停止',
        onOk: () => {
          stopDispatchApi({ taskId: record.taskId })
            .then(onHttpResponse)
            .then(() => {
              this.queryScheduleRecordList()
            })
            .catch(() => {})
        }
      })
    },

    async handleHandExec(record) {
      // 弹框询问是否全量调度（全量调度不过滤系统中已存在的数据）
      const confirm = this.$confirm({
        content: '是否进行单次全量调度（全量调度不过滤系统中已存在的数据）',
        okText: '全量调度',
        cancelText: '非全量调度',
        maskClosable: true,
        onOk: () => {
          this._handleHandExec(record, true)
        },
        onCancel: (e) => {
          if (typeof e === 'object' && e.triggerCancel) {
            confirm.destroy()
          } else {
            this._handleHandExec(record, false)
            return Promise.resolve()
          }
        }
      })
    },

    async _handleHandExec({ spiderId, taskConfig, spiderClassType }, isAll) {
      let apiFunc
      if (spiderClassType === 'news') {
        apiFunc = execNewsItemApi
      } else {
        apiFunc = execApiItemApi
      }
      let res = await apiFunc({
        spiderId,
        spiderLevel: taskConfig.spiderLevel,
        isAll
      })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },

    handleEdit({ spiderId, spiderClassType }) {
      this.$router.push({
        name: 'site_create_form',
        query: {
          spiderId,
          type: spiderClassType
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.task-manage-container {
  width: 100%;
  padding: 16px;

  .table-container {
    background-color: white;
    padding: 0 16px;
    margin-top: 16px;
  }
}
</style>
